import React from 'react'

export interface TabsContextValue {
  currentTab: string | number
  onTabChange: (value: string | number) => void
}

export const TabsContext = React.createContext<TabsContextValue | null>(null)

export function useTabsContext(): TabsContextValue {
  const ctx = React.useContext(TabsContext)
  if (!ctx) throw new Error('useTabsContext must be used inside Tabs')
  return ctx
}
